import { useGetPost } from '@repo/api/post/useGetPost';
import { ErrorMessage } from '@repo/types/messages/error';
import { PostPublic } from '@repo/types/posts';
import { useNavigate, useParams } from 'react-router';

import ErrorState from '@/components/features/meeting/ErrorState';
import PostCard from '@/components/features/post/PostCard';
import PostCardSkeleton from '@/components/features/post/PostCardSkeleton';
import NotFoundPage from '@/pages/errors/NotFoundPage';

export default function PostPage() {
  const { id } = useParams();
  const postId = Number(id);
  const { data, isPending, isError, errorMessage } = useGetPost(postId);

  if (!id || Number.isNaN(postId)) {
    return <NotFoundPage />;
  }

  return (
    <div className={'base-direction-row'}>
      <div className={'flex w-full flex-col items-center justify-center'}>
        <PostPageContent isError={isError} errorMessage={errorMessage} isPending={isPending} data={data} />
      </div>
    </div>
  );
}

interface PostPageContentProps {
  isError: boolean;
  isPending: boolean;
  errorMessage?: ErrorMessage;
  data?: PostPublic;
}

function PostPageContent(postPageContentProps: PostPageContentProps) {
  const { isError, errorMessage, isPending, data } = postPageContentProps;

  const navigate = useNavigate();

  if (isError) {
    return <ErrorState errorMessage={errorMessage} />;
  }

  if (isPending) {
    return <PostCardSkeleton />;
  }

  if (data) {
    return <PostCard post={data} onDeleted={() => navigate('/', { replace: true })} className="max-w-6xl" />;
  }

  return <NotFoundPage />;
}
